import { motion } from "framer-motion";
import { useState } from "react";
import { Empty, Tag, Tooltip } from "antd";

//APP
import { obterExecucoes } from "../talhoesFinalizados/meta";
import { Item__EquipeCliente } from "../../../../../../../services/Equipe/GET";
import { TalhaoFinalizadoSaida } from "../../../meta/dados_modais";
import { leadZero, transition_default } from "../../../../../../../utils";

//COMPONENTS
import { Gap } from "../../../../../../../Components/CustomUi/gap";
import { RowItem } from "../../../../../../../Components/CustomUi/table/rowItem";
import { RowTable } from "../../../../../../../Components/CustomUi/table/rowTable";
import { Accordion } from "../../../../../../../Components/CustomUi/accordion";
import { BodyTable } from "../../../../../../../Components/CustomUi/table/bodyTable";
import { HeaderTable } from "../../../../../../../Components/CustomUi/table/headerTable";
import { ProgressCircle } from "../../../../linhaDoTempo/components/ListaAtividades/components/CardAtv/components/ProgressCircle";

//PROPS
interface Props {
    lista_talhoes_finalizados: TalhaoFinalizadoSaida[];
    data_equipe_cliente: Item__EquipeCliente[];
    cod_propriedade_selecionada?: number;
    cod_talhao_selecionado?: number;
    cod_subarea_selecionada?: number;
}

export const TalhoesPlanejadas: React.FC<Props> = ({ lista_talhoes_finalizados, data_equipe_cliente, cod_propriedade_selecionada, cod_talhao_selecionado, cod_subarea_selecionada }) => {

    const [open_accordion, setOpen_accordion] = useState<number>(null);

    function filtrarLista() {
        if (cod_propriedade_selecionada && !cod_talhao_selecionado) {
            return lista_talhoes_finalizados.filter(i => i.cod_propriedade === cod_propriedade_selecionada);
        }
        if (cod_propriedade_selecionada && cod_talhao_selecionado) {
            if (cod_subarea_selecionada) {
                return lista_talhoes_finalizados.filter(i => i.cod_talhao === cod_subarea_selecionada);
            }
            return lista_talhoes_finalizados.filter(i => i.cod_talhao === cod_talhao_selecionado || i.cod_talhao_pai === cod_talhao_selecionado);
        }
        return lista_talhoes_finalizados;
    }

    return (
        <section style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>

            {filtrarLista().map(({ nome_talhao, is_subarea, cod_talhao, nome_propriedade, atvs_planejadas, atvs_executadas, atvs_concluidas }, idx) => {
                return (
                    <Accordion
                        label={<div style={{
                            display: 'flex',
                            flexDirection: 'column',
                            textAlign: 'left'
                        }}>
                            <span style={{ fontWeight: 600, margin: 0 }}>{nome_talhao} <span style={{ color: 'var(--text-color-light)', fontSize: 12 }}>{is_subarea ? '(Subarea)' : ''}</span></span>
                            <span style={{ fontWeight: 600, fontSize: 11, color: 'var(--primary-color)', margin: 0 }}>{nome_propriedade}</span>
                        </div>}
                        open={cod_talhao === open_accordion}
                        trigger={open_accordion === cod_talhao ? () => { setOpen_accordion(null) } : () => { setOpen_accordion(cod_talhao) }}
                        single
                        extra={<Tags qtd_executadas={atvs_executadas?.length} qtd_planejadas={atvs_planejadas?.length} qtd_concluidas={atvs_concluidas?.length} />}
                    // disabled={atvs_executadas.length === 0}
                    >
                        <motion.div
                            initial={{ opacity: 0, y: -5 }}
                            animate={{ opacity: 1, y: 0 }}
                            transition={{ ...transition_default }}
                        >

                            <Gap value={10} type="column" />

                            <HeaderTable
                                itens={[
                                    { valor: 'Operação', width: 121 },
                                    { valor: 'Atividade', width: 230.5 },
                                    { valor: 'Dias', width: 60 },
                                    { valor: 'Data', width: 165.5 },
                                    { valor: 'Conclusão', width: 100 },
                                    { valor: 'Patrimonios', width: 100 },
                                    { valor: 'Insumos', width: 100 },
                                ]}
                            />

                            <BodyTable>
                                {(obterExecucoes(atvs_planejadas, atvs_executadas, data_equipe_cliente).planejadas ?? []).map(({ operacao, descricao, dias, data, conclusao, patrimonios, insumos, referencia }) => {
                                    return (
                                        <RowTable>
                                            <RowItem width={120} style={{ textTransform: 'capitalize', fontSize: 13 }}>
                                                {String(operacao)?.toLowerCase()}
                                            </RowItem>
                                            <RowItem width={231} style={{ textTransform: 'capitalize', fontWeight: 500, lineHeight: 1.1, fontSize: 13 }}>
                                                {String(descricao)?.toLowerCase()}
                                            </RowItem>
                                            <RowItem width={60} style={{ padding: 0 }}>
                                                <div style={{
                                                    position: 'relative', width: 60, height: 54.2,
                                                    background: Number(dias) == 0 ? 'var(--atv-positivo)' : (Number(dias) < 0 ? 'var(--atv-negativo-light)' : 'var(--atv-positivo-light)'),
                                                    padding: 10, display: 'flex', alignItems: 'center', justifyContent: 'center',
                                                    color: Number(dias) == 0 ? 'white' : (Number(dias) < 0 ? 'var(--atv-negativo)' : 'var(--atv-positivo)'), fontWeight: 600
                                                }}
                                                >
                                                    {Number(dias) > 0 ? '+' : ''}{dias}

                                                    <div style={{
                                                        width: 10,
                                                        height: 4,
                                                        background: (Number(dias) < 0 ? 'var(--atv-negativo)' : 'var(--atv-positivo)'),
                                                        position: 'absolute',
                                                        top: 5,
                                                        left: referencia === 1 ? 2 : (referencia === 2 ? 25 : 48),
                                                        borderRadius: '5px'
                                                    }}></div>
                                                </div>
                                            </RowItem>
                                            <RowItem width={165} style={{ fontSize: 13 }}>
                                                {data}
                                            </RowItem>
                                            <RowItem width={100}>
                                                {conclusao}
                                            </RowItem>
                                            <RowItem width={100}>
                                                <Tooltip title={patrimonios.map((i) => { return (<>- {String(i.patrimonio_nome)}<br /></>) })}>
                                                    <div style={{
                                                        width: 30, height: 30, borderRadius: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center',
                                                        background: Number(dias) == 0 ? 'var(--atv-positivo)' : (Number(dias) < 0 ? 'var(--atv-negativo-light)' : 'var(--atv-positivo-light)'),
                                                        color: Number(dias) == 0 ? 'white' : (Number(dias) < 0 ? 'var(--atv-negativo)' : 'var(--atv-positivo)'), fontWeight: 600,
                                                        opacity: (patrimonios ?? [])?.length === 0 ? 0.3 : 1
                                                    }}
                                                    >
                                                        {leadZero((patrimonios ?? [])?.length)}
                                                    </div>
                                                </Tooltip>
                                            </RowItem>
                                            <RowItem width={105}>
                                                <Tooltip title={insumos.map((i) => { return (<>- {String(i.insumo_nome)}<br /></>) })}>
                                                    <div style={{
                                                        width: 30, height: 30, borderRadius: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center',
                                                        background: Number(dias) == 0 ? 'var(--atv-positivo)' : (Number(dias) < 0 ? 'var(--atv-negativo-light)' : 'var(--atv-positivo-light)'),
                                                        color: Number(dias) == 0 ? 'white' : (Number(dias) < 0 ? 'var(--atv-negativo)' : 'var(--atv-positivo)'), fontWeight: 600,
                                                        opacity: (insumos ?? [])?.length === 0 ? 0.3 : 1
                                                    }}
                                                    >
                                                        {leadZero((insumos ?? [])?.length)}
                                                    </div>
                                                </Tooltip>
                                            </RowItem>

                                        </RowTable>
                                    )
                                })}
                            </BodyTable>

                            {(obterExecucoes(atvs_planejadas, atvs_executadas, data_equipe_cliente).planejadas ?? []).length === 0 && (
                                <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} description={"Nenhuma atividade planejada!"} />
                            )}

                        </motion.div>
                    </Accordion>
                )
            })}

            {lista_talhoes_finalizados.length === 0 && (
                <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} description={"Nenhum talhão foi finalizado!"} />
            )}

        </section>
    )
};


//PROPS
interface PropsTags {
    qtd_planejadas: number,
    qtd_executadas: number,
    qtd_concluidas: number,
}
const Tags: React.FC<PropsTags> = ({ qtd_planejadas, qtd_executadas, qtd_concluidas }) => {
    return (
        <div style={{
            display: 'flex',
            gap: 5
        }}>
            <Tag color="purple" style={{ fontWeight: 500, alignSelf: 'center', opacity: qtd_planejadas === 0 ? 0.5 : 1 }}>{leadZero(qtd_planejadas)} planejadas</Tag>

            <ProgressCircle
                progress={(qtd_planejadas === 0 || qtd_concluidas === 0) ? 0 : Math.round((qtd_concluidas / qtd_planejadas) * 100)}
                textColor={"#0958d9"}
                circleColor={"#E6F4FF"}
                progressColor={"#0958d9"}
            />
        </div>
    )
}